import { ApiResult, request, safeRequest } from '@synergy/api';

import { ShoppingCartDto } from '../models/dto/shopping-cart-dto';
import { ShoppingCartMinimal } from '../models/shopping-cart-minimal';
import { WishListId } from '../models/wish-list-list-item';

export class ShoppingCartApi {
    constructor(protected baseUrl: string) {}

    public getShoppingCart = (): Promise<ApiResult<ShoppingCartDto>> => {
        return safeRequest(
            () => request.get(`${this.baseUrl}/shopping-cart`),
            response => response.data
        );
    };

    public getShoppingCartMinimal = (): Promise<ApiResult<ShoppingCartMinimal>> => {
        return safeRequest(
            () => request.get(`${this.baseUrl}/shopping-cart-minimal`),
            response => response.data
        );
    };

    public emptyShoppingCart = (): Promise<ApiResult> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/shopping-cart/items/empty`),
            response => response.data
        );
    };

    public submitShoppingCart = (): Promise<ApiResult> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/shopping-cart/submit`),
            response => response.data
        );
    };

    public submitInquiry = (): Promise<ApiResult> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/shopping-cart/submit-inquiry`),
            response => response.data
        );
    };

    public refreshShoppingCart = (): Promise<ApiResult<ShoppingCartDto>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/shopping-cart/items/refresh`),
            response => response.data
        );
    };

    public addToWishlist = (wishListId: WishListId): Promise<ApiResult> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/shopping-cart/add-to-wish-list`, { wishListId }),
            response => response.data
        );
    };

    public updateFunctionalAsset = (supplierId: number, functionalAssetId: number): Promise<ApiResult> => {
        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/shopping-cart/suppliers/${supplierId}/update-functional-asset`, {
                    functionalAssetId,
                }),
            response => response.data
        );
    };
}
